import { makeStyles } from '@material-ui/core/styles';

export const useLabelStyles = makeStyles((theme) => ({
  filled: {
    color: theme.colors.fgSubtle,
    transform: 'translate(12px, 14.5px) scale(1)',
    '&.MuiInputLabel-shrink': {
      transform: 'translate(12px, 8px) scale(0.75)',
    },
  },
}));

export const useHelperStyles = makeStyles((theme) => ({
  root: {
    marginLeft: 0,
  },
}));

export const useFormControlStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 4,
    '& .MuiSelect-select:focus': {
      background: 'transparent',
    },
    '& .MuiFilledInput-root': {
      backgroundColor: theme.colors.bgDefault,
      borderRadius: 4,
      border: `1px solid ${theme.colors.borderDefault}`,
      color: theme.colors.fgDefault,
      '&:focused': {
        borderColor: theme.colors.borderPrimaryBase,
      },
      '&:hover': {
        borderColor: theme.colors.borderDark,
      },
      '&.Mui-error': {
        borderColor: theme.colors.borderDangerBase,
      },
    },
    '& .MuiFilledInput-root.Mui-focused': {
      backgroundColor: theme.colors.bgDefault,
      borderRadius: 4,
      borderColor: theme.colors.borderPrimaryBase,
      '&:hover': {
        borderColor: theme.colors.borderPrimaryBase,
      },
    },
    '& .MuiFilledInput-underline:before': {
      borderBottomWidth: 0,
    },
    '& .MuiFilledInput-underline:after': {
      borderBottomWidth: 0,
    },
  },
}));
